<template>
  <div
    id="swipeSurface"
    v-touch="{ down: swipeDown }"
    class="h-100"
    @click="swipeDown"
  >
    <div class="swipe-bar bg-grey-lighten-2 rounded-lg"></div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from '@/stores/global.ts';

const globalStore = useGlobalStore();

const swipeDown = () => {
  globalStore.drawer = false;
};
</script>

<style lang="scss" scoped>
.swipe-bar {
  height: 4px;
  width: 80px;
}
</style>
